export default __webpack_public_path__ + "static/media/medical-form-icon.54cb3e7c.png";